import { render, staticRenderFns } from "./RegularLineDetail.vue?vue&type=template&id=5f606dda"
import script from "./RegularLineDetail.vue?vue&type=script&lang=js"
export * from "./RegularLineDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports